import Content from "../../help/stock-receipt-import.mdx";

export function StockReceiptImportHelpPage() {
  return <Content />;
}
